<template >
  <div class="body">
    <el-container>
      <left-meun ref="_leftMeun" @initData="initData"></left-meun>
      <el-container>
        <el-header class="header">
          <span>
            <span class="left">
              <span class="el-icon-s-fold"></span>
              <span class="el-icon-refresh-right"></span>
            </span>
            <el-breadcrumb class="left" separator="/">
              <el-breadcrumb-item>
                <a href="#">首页</a>
              </el-breadcrumb-item>
              <el-breadcrumb-item>
                <a href="#">Dashboard</a>
              </el-breadcrumb-item>
              <el-breadcrumb-item>主控台</el-breadcrumb-item>
            </el-breadcrumb>
          </span>
          <head-right></head-right>
        </el-header>
        <el-main>
          <el-row>
            <el-col :span="24">
              <div class="xuenianfenbu">
                <div class="header">
                  <span class="el-icon-eleme"></span>
                  <span>学年分布</span>

                  <div class="right">
                    <div style="float: left; line-height: 50px">
                      <a style="margin-left: 10px" href="#">今日</a>
                      <a style="margin-left: 10px" href="#">本月</a>
                      <a style="margin-left: 10px" href="#">全年</a>
                    </div>
                    <div style="float: left; margin-left: 15px; line-height: 50px">
                      <el-date-picker v-model="value1" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                    </div>
                  </div>
                </div>
                <hr style="filter: alpha(opacity=100, finishopacity=0, style=3)" width="100%" color="#e4e7e9" size="1" />
                <div class="studentnums">
                  <span>学生人数</span>
                </div>
                <div class="studentnumsranking">
                  <span>学生人数排行</span>
                  <ol>
                    <li>
                      <p class="index">1</p>
                      <p class="year">2020年</p>
                      <p class="nums">1000000</p>
                    </li>
                    <li>
                      <p class="index">2</p>
                      <p class="year">2020年</p>
                      <p class="nums">1000000</p>
                    </li>
                    <li>
                      <p class="index">3</p>
                      <p class="year">2020年</p>
                      <p class="nums">1000000</p>
                    </li>
                    <li>
                      <p class="index">4</p>
                      <p class="year">2020年</p>
                      <p class="nums">1000000</p>
                    </li>
                    <li>
                      <p class="index">5</p>
                      <p class="year">2020年</p>
                      <p class="nums">1000000</p>
                    </li>
                    <li>
                      <p class="index">6</p>
                      <p class="year">2020年</p>
                      <p class="nums">1000000</p>
                    </li>
                    <li>
                      <p class="index">7</p>
                      <p class="year">2020年</p>
                      <p class="nums">1000000</p>
                    </li>
                  </ol>
                </div>
              </div>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <div class="xiaoyouhuaxiang">
                <div class="head">
                  <span class="el-icon-eleme icon"></span>
                  <p class="title">校友画像</p>
                  <span class="el-icon-eleme icon" style="float: right"></span>
                </div>
                <hr style="filter: alpha(opacity=100, finishopacity=0, style=3)" width="100%" color="#e4e7e9" size="1" />
              </div>
            </el-col>
            <el-col :span="12">
              <el-row>
                <el-col :span="12">
                  <div class="more">新增校友</div>
                </el-col>
                <el-col :span="12">
                  <div class="more">地区分布</div>
                </el-col>
                <el-col :span="12">
                  <div class="more">行业分布</div>
                </el-col>
                <el-col :span="12">
                  <div class="more">专业分布</div>
                </el-col>
                <el-col :span="12">
                  <div class="more">认证分布</div>
                </el-col>
                <el-col :span="12">
                  <div class="more">联络分析</div>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import leftMeun from '@/components/layout/leftMeun'
import headRight from '@/components/layout/headRight'

export default {
  //   name: 'index',
  //   components: {
  //   },
  //   data() {
  //     return {}
  //   },
  components: {
    leftMeun,
    headRight
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath)
    }
  }
}
</script>

<style lang="less" scoped>
.header {
  width: 100%;
  height: 50px;
  background-color: #fff;
  border-radius: 5px;
}
.header span {
  line-height: 50px;
  margin-right: 15px;
}
.header .left {
  float: left;
}
.header .right {
  float: right;
}
.xuenianfenbu {
  width: 100%;
  height: 370px;
  border-radius: 5px;
  background-color: #ffffff;
  float: left;
}
.xuenianfenbu .title {
  height: 50px;
  float: left;
}
.xuenianfenbu .header {
  width: 90%;
  padding-left: 20px;
}
.xuenianfenbu .header .right {
  float: right;
}
.xuenianfenbu .studentnums {
  width: 65%;
  height: 320px;
  padding: 10px;
  float: left;
}
.xuenianfenbu .studentnumsranking {
  width: 30%;
  height: 320px;
  padding: 10px;
  float: left;
}
// 学生人数排行 小li 父容器
.xuenianfenbu .studentnumsranking li {
  overflow: hidden;
  margin-top: 10px;
}
// 学生人数排行 排名下标
.studentnumsranking li .index {
  width: 30px;
  height: 30px;
  border-radius: 4em;
  text-align: center;
  line-height: 30px;
  background: #e4f6fd;
  float: left;
}
// 学生人数排行 年份
.studentnumsranking li .year {
  float: left;
  margin-left: 10px;
  line-height: 30px;
}
// 学生人数排行 人数
.studentnumsranking li .nums {
  float: right;
  line-height: 30px;
}
// 校友画像
.xiaoyouhuaxiang {
  //   width: 824px;
  height: 510px;
  margin-top: 15px;
  border-radius: 5px;
  background-color: #ffffff;
  //   float: left;
}
// 校友画像 标题拦
.xiaoyouhuaxiang .head {
  width: 100%;
  height: 50px;
}
.xiaoyouhuaxiang .head .icon {
  line-height: 50px;
  margin-left: 15px;
  margin-right: 15px;
  float: left;
}
.xiaoyouhuaxiang .head .title {
  line-height: 50px;
  float: left;
}
.more_parent {
  background-color: red;
  //   float: left;
  overflow: hidden;
}
.more {
  //   width: 50%;
  height: 210px;
  margin-top: 15px;
  margin-left: 15px;
  padding: 10px;
  border-radius: 5px;
  background-color: #ffffff;
  //   float: left;
}
</style>


// WEBPACK FOOTER //
// src/pages/main.vue